import React from 'react';
import { css } from '@linaria/core';
import { brand } from '@terveystalo/design-system-theme';
import { classnames } from '../../utils';
import { getTypographyStyles } from './utils';
const variants = {
    l: css `
    font-family: ${brand.body.font.l.family};
    font-size: ${brand.body.font.l.size};
    line-height: ${brand.body.font.l.lineHeight};
    letter-spacing: ${brand.body.font.l.letterSpacing};
  `,
    m: css `
    font-family: ${brand.body.font.m.family};
    font-size: ${brand.body.font.m.size};
    line-height: ${brand.body.font.m.lineHeight};
    letter-spacing: ${brand.body.font.m.letterSpacing};
  `,
};
const defaultColor = css `
  color: ${brand.body.color.default.content};
`;
const defaultWeights = {
    l: css `
    font-weight: ${brand.body.font.l.weight};
  `,
    m: css `
    font-weight: ${brand.body.font.m.weight};
  `,
};
/**
 * Text component for body texts
 */
export function Text(props) {
    const { as: Component = 'span', size = 'm', className, color, weight, ...rest } = props;
    const overrides = getTypographyStyles({ color, weight, defaultColor, defaultWeight: defaultWeights[size] });
    return (React.createElement(Component, { className: classnames(variants[size], ...overrides.className, className), style: overrides.style, ...rest }));
}


import "../../../css/atoms/Typography/Text.css";
